@if(content){
<modal-layout-right (close)="close()">
    <ng-container ngProjectAs="[modalTitle]">
        <!-- modal title -->
        <h5 *iCms="'title' of content"
            class="h3"></h5>
    </ng-container>

    <ng-container ngProjectAs="[modalBody]">
        <ng-form #editForm="ngForm"
                 class="w-12">
            <div class="p-b p-r-4 p-l-4">
                <address-fieldset [data]="data.addressData"
                                  [form]="editForm">
                </address-fieldset>
            </div>
        </ng-form>
    </ng-container>

    <ng-container ngProjectAs="[modalFooter]">
        <div class="p-a-5">
            @if (content.saveBtnCopy) {
            <action [status]="status"
                    class="w-12 button"
                    (click)="saveAddress()">
                <span *iCms="'saveBtnCopy' of content"></span>
            </action>
            <result [status]="status"
                    class="block"></result>
            }
            @if (content.closeBtnCopy) {
            <div class="w-12 flex flex-justify-center">
                <button class="button-inline-1 m-t m-t-3-s"
                        (click)="close()">
                    <span *iCms="'closeBtnCopy' of content"></span>
                </button>
            </div>
            }
        </div>
    </ng-container>

</modal-layout-right>
}